import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgIf } from '@angular/common';
import { LoadingShimmerModule } from 'loading-shimmer';
import { Breadcrumb } from '../../../models/shared/stylesheet/breadcrumb';
import { TabBarItem } from '../../tab-bar/tab-bar-item';
import { HeaderContainerComponent } from '../header-container/header-container.component';
import { BreadcrumbsComponent } from '../../../views/shared/components/breadcrumbs/breadcrumbs.component';
import { TabBarComponent } from '../../tab-bar/tab-bar.component';
import { StatusPill } from '../../../models/shared/status-pill';
import { StatusPillComponent } from '../../pills/status-pill.component';

@Component({
  selector: 'app-breadcrumb-header',
  templateUrl: './breadcrumb-header.component.html',
  styleUrls: ['./breadcrumb-header.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    LoadingShimmerModule,
    HeaderContainerComponent,
    BreadcrumbsComponent,
    TabBarComponent,
    StatusPillComponent
  ]
})
export class BreadcrumbHeaderComponent {
  @Input() breadcrumbs: Breadcrumb[] = [];
  @Input() headerTitle: string = '';
  @Input() tabs: TabBarItem[] = [];
  @Input() isLoading: boolean = false;
  @Input() statusPill: StatusPill | null = null;
  @Output() selectedTab = new EventEmitter<TabBarItem>(true);
}
